var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 20",
    style: {
      enableBackground: "new 0 0 18 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M16,2h-1V1c0-0.5-0.5-1-1-1s-1,0.5-1,1v1H5V1c0-0.5-0.4-1-1-1S3,0.5,3,1v1H2C0.9,2,0,2.9,0,4l0,14 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4C18,2.9,17.1,2,16,2z M15,18H3c-0.6,0-1-0.5-1-1V7h14v10C16,17.5,15.5,18,15,18z M5,9h3 c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1v-3C4,9.4,4.4,9,5,9z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTggMjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE4IDIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgk8cGF0aCBpZD0icGF0aC0xIiBkPSJNMTYsMmgtMVYxYzAtMC41LTAuNS0xLTEtMXMtMSwwLjUtMSwxdjFINVYxYzAtMC41LTAuNC0xLTEtMVMzLDAuNSwzLDF2MUgyQzAuOSwyLDAsMi45LDAsNGwwLDE0CgkJYzAsMS4xLDAuOSwyLDIsMmgxNGMxLjEsMCwyLTAuOSwyLTJWNEMxOCwyLjksMTcuMSwyLDE2LDJ6IE0xNSwxOEgzYy0wLjYsMC0xLTAuNS0xLTFWN2gxNHYxMEMxNiwxNy41LDE1LjUsMTgsMTUsMTh6IE01LDloMwoJCWMwLjYsMCwxLDAuNCwxLDF2M2MwLDAuNi0wLjQsMS0xLDFINWMtMC42LDAtMS0wLjQtMS0xdi0zQzQsOS40LDQuNCw5LDUsOXoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };